import { alpha, Box, styled, Divider } from "@mui/material";
import { StyleUtils } from "@/constants/style.utils";

export const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: "36.4rem",
  padding: theme.spacing(3.2, 1),
  margin: theme.spacing(0, "auto"),
  minHeight: "100%",
}));

export const HelpItemWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const SectionDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(3, 0),
  borderColor: alpha(theme.palette.common.white, 0.1),
  borderWidth: "1px",
  "&::before, &::after": {
    borderColor: alpha(theme.palette.common.white, 0.1),
    borderWidth: "1px",
  },
}));

export const SectionHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1, 0),
}));

export const ThumbnailContainer = styled(Box)(({ theme }) => ({
  width: "56px",
  height: "56px",
  backgroundColor: theme.palette.grey.card || "#383838",
  borderRadius: StyleUtils.border.radius(1.5),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "28px",
  border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
  boxShadow: `0px 4px 12px ${alpha(theme.palette.common.black, 0.3)}`,
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: `0px 6px 16px ${alpha(theme.palette.common.black, 0.4)}`,
    borderColor: alpha(theme.palette.common.white, 0.4),
  },
}));

export const HintAccordion = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.grey.card || "#383838", 0.8),
  borderRadius: StyleUtils.border.radius(1),
  border: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
  marginBottom: theme.spacing(1),
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: alpha(theme.palette.grey.card || "#383838", 1),
    borderColor: alpha(theme.palette.common.white, 0.2),
  },
}));
